import * as Sentry from '@sentry/react';

export const initSentry = () => {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) return;

  Sentry.init({
    dsn,
    environment: import.meta.env.MODE,
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
    // 20 % of transactions in prod, 100 % in dev
    tracesSampleRate: import.meta.env.PROD ? 0.2 : 1.0,
    // 10 % of sessions recorded; 100 % on error
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0,
    // Don't send localhost noise to Sentry
    beforeSend(event) {
      if (import.meta.env.DEV) return null;
      return event;
    },
  });
};

export const setSentryUser = (user: { id: string; email?: string; role?: string }) => {
  Sentry.setUser(user);
};

export const clearSentryUser = () => {
  Sentry.setUser(null);
};

export { Sentry };
